import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseService } from "./base.sevice";
import { ResetPassword } from "../models/ResetPassword";
import { Manager } from "../models/Manager";

@Injectable()
export class ManagerService extends BaseService {

    keyUser = 'qr_mng_user';
    keyToken = 'qr_mng_token';
    url = `${environment.apiBaseUrl}/managers`;

    constructor(private http: HttpClient) {
        super();
    }

    getMe() {
        return this.http.get(`${this.url}/me`);
    }

    update(item: Manager) {
        return this.http.put(`${this.url}/${item.id}`, item);
    }

    updatePassword(id: string, item: ResetPassword){
        return this.http.put(`${this.url}/${id}/password`, item);
    }

    setLoggedUser(user: Manager) {
        localStorage.setItem(this.keyUser, JSON.stringify(user));
    }

    getLoggedUser() {
        var userJson = localStorage.getItem(this.keyUser);
        return userJson ? JSON.parse(userJson) : null;
    }

    getToken() {
        return localStorage.getItem(this.keyToken);
    }

    setToken(token: string) {
        localStorage.setItem(this.keyToken, token);
    }

    logout() {
        localStorage.removeItem(this.keyToken);
        localStorage.removeItem(this.keyUser);
    }
}